/* eslint-disable */







import { OPEN_ENDED_PATTERNS, SUGGESTED_PROMPTS } from './dictionaries';
import { INTENTS_REQUIRING_ID, INTENTS_WITH_ROUTE_FALLBACK } from './resolver';

function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }

const CONFIDENCE_THRESHOLD = 0.55;












/**
 * Determine whether to handle in Layer 1 or escalate to Layer 2.
 * Returns the populated `handoff` object + optional `layer2_input`.
 */
export function buildHandoff(input) {
    const {
        intent, confidence,
        normalized, tokens, entities,
        ctx, actions,
    } = input;

    let reason;
    let shouldEscalate = false;

    // ── Rule 1: Open-ended question ───────────────────────────────────────────
    // Only check this if confidence is low, otherwise trust the specific intent (e.g. search)
    if (confidence < 0.8 && isOpenEndedQuestion(normalized)) {
        shouldEscalate = true;
        reason = 'OPEN_ENDED_QUESTION';
    }

    // ── Rule 4: Framework Ambiguity ───────────────────────────────────────────
    // Compliance commands are deterministic even with ambiguous framework – just pick first
    const COMPLIANCE_DETERMINISTIC_INTENTS = [
        'compliance_readiness_view',
        'compliance_gaps_view',
        'compliance_control_view',
        'compliance_report_generate',
    ];
    if (!shouldEscalate && input.frameworks_ambiguous && !COMPLIANCE_DETERMINISTIC_INTENTS.includes(intent)) {
        shouldEscalate = true;
        reason = 'AMBIGUOUS_FRAMEWORK';
    }

    // ── Rule 5: Missing required entity ──────────────────────────────────────
    if (!shouldEscalate) {
        const needsId = INTENTS_REQUIRING_ID.includes(intent);
        const hasFallback = INTENTS_WITH_ROUTE_FALLBACK.includes(intent) &&
            /\/(?:policy|policies)\/[^/]+/.test(ctx.current_route);
        if (needsId && !entities.policy_id && !hasFallback) {
            shouldEscalate = true;
            reason = 'MISSING_REQUIRED_ENTITY';
        }
    }

    // ── Rule 6: Actions list is empty ─────────────────
    // Compliance intents now produce API_CALL actions – they are still deterministic
    const NON_ACTION_INTENTS = [
        'help',
        'audit_logs_view',
        'compliance_readiness_view',
        'compliance_gaps_view',
        'compliance_control_view',
        'compliance_report_generate',
    ];
    if (!shouldEscalate && !NON_ACTION_INTENTS.includes(intent) && actions.length === 0) {
        shouldEscalate = true;
        reason = intent === 'clarify' ? 'AMBIGUOUS_COMMAND' : 'UNKNOWN_INTENT';
    }

    // ── Rule 7: Low confidence (Lowest Priority) ───────────────────────────────
    if (!shouldEscalate && confidence < CONFIDENCE_THRESHOLD) {
        shouldEscalate = true;
        reason = 'LOW_CONFIDENCE';
    }

    if (!shouldEscalate) {
        return {
            handoff: { decision: 'HANDLE_IN_LAYER1' },
            extraActions: [],
        };
    }

    // ── Build escalation payload ──────────────────────────────────────────────
    const layer2Input = {
        normalized,
        tokens,
        entities: {
            policy_id: entities.policy_id,
            policy_title: entities.policy_title,
            frameworks: entities.frameworks,
            control_ids: entities.control_ids,
            search_query: entities.search_query,
            time_range: entities.time_range,
        },
        ctx_snapshot: ctx,
    };

    const suggestedPrompts = _nullishCoalesce(SUGGESTED_PROMPTS[_nullishCoalesce(reason, () => ('UNKNOWN_INTENT'))], () => ([]));

    const handoff = {
        decision: 'ESCALATE_TO_LAYER2',
        reason,
        suggested_prompts: suggestedPrompts,
    };

    const escalateAction = {
        type: 'OPEN_MODAL',
        name: 'CommandBarAssist',
        props: {
            mode: 'layer2',
            reason,
            layer2_input: layer2Input,
        },
    };

    return { handoff, layer2_input: layer2Input, extraActions: [escalateAction] };
}

// ─── Helpers ─────────────────────────────────────────────────────────────────

function isOpenEndedQuestion(normalized) {
    return OPEN_ENDED_PATTERNS.some(p => p.test(normalized));
}
